module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-news-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": '/post/' + _vm.news.uid + '.html',
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "left-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.news.photo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "main-title"
  }, [_vm._v("\n            " + _vm._s(_vm.news.title.length > 50 ? _vm.news.title.substring(0, 48) + '...' : _vm.news.title) + "\n\n\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("\n            " + _vm._s(_vm.news.intro.length > 160 ? _vm.news.intro.substring(0, 160) + '...' : _vm.news.intro) + "\n\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "tag"
  }), _vm._v(" "), _c('div', {
    staticClass: "auther-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                    " + _vm._s(_vm.news.author.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v("\n                    " + _vm._s(_vm.timeAgo(_vm.news.time)) + "\n                ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ef02a78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PcNewsItem.vue
// module id = 153
// module chunks = 1